
export function remove () {
  localStorage.removeItem('token')
  localStorage.removeItem('number')
  localStorage.removeItem('name')
  localStorage.removeItem('email')
  localStorage.removeItem('id')
  localStorage.removeItem('gradeId')
  localStorage.removeItem('loginTime')
  localStorage.removeItem('lastPractice')
  localStorage.removeItem('continuePractice')
  localStorage.removeItem('practicedToday')
  localStorage.removeItem('refreshTime')
  localStorage.removeItem('classTime')
  localStorage.removeItem('breakTime')
  localStorage.removeItem('startStudy')
  localStorage.removeItem('startBreak')
  localStorage.removeItem('userData')
  localStorage.removeItem('userNumber')
  localStorage.removeItem('avatar')
  localStorage.removeItem('lastTypingActive')
  localStorage.removeItem('lastTypingHistoryActive')
}

export function getUser () {
  return JSON.parse(localStorage.getItem('userData'))
}

export function getUserAvator () {
  return '#FF6699'
}
